module.exports = __webpack_public_path__ + "static/media/articles3.74eeff68.jfif";